export default __webpack_public_path__ + "static/media/CLICHY (168 sur 176).ace9642f.jpg";